import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { keyFieldsReset, isValidConfigSelector } from 'redux/keyFieldsSlice';
import useMetricsRequest from 'hooks/useMetricsRequest';
import useWizardNavigation from 'hooks/useWizardNavigation';

import NavigationButtons from 'components/NavigationButtons';
import LocationField from 'components/LocationSettings/LocationSettings';
import DateTimeField from 'components/DateTimeSettings/DateTimeSettings';

import { StyledFormContainer } from 'components/StyledComponents';

const IdentifyKeyFields: React.FC = () => {
  const dispatch = useDispatch();
  const isValidConfig = useSelector(isValidConfigSelector);
  const { requestMetrics, isLoading } = useMetricsRequest();
  const { previous, next } = useWizardNavigation();

  const onPrevious = () => {
    previous();
    dispatch(keyFieldsReset());
  };

  const onMetricsRequested = async () => {
    try {
      await requestMetrics();
      next();
    } catch {}
  };

  return (
    <>
      <StyledFormContainer>
        <LocationField />
        <DateTimeField />
      </StyledFormContainer>
      <NavigationButtons
        onPrevious={onPrevious}
        nextLabel="Retrieve metrics"
        nextIsDisabled={!isValidConfig}
        nextIsLoading={isLoading}
        onNext={onMetricsRequested}
      ></NavigationButtons>
    </>
  );
};

export default IdentifyKeyFields;
